import React from 'react';
import styled from 'styled-components';
import InputLabel from '../inputLabel/InputLabel';

// tslint:disable-next-line:variable-name
const SInputOuterWrap = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 800px) {
    flex-basis: 0;
  }
`;

// tslint:disable-next-line:variable-name
const SInputInnerWrap = styled.div<{ error: boolean; disabled: boolean; background: InputBackground }>(({
  theme, error, disabled, background,
}) => {
  const borderColor = error ? theme.colors.error : theme.colors.border;
  const disabledStyle = disabled ? { opacity: 0.5 } : {};

  return {
    backgroundColor: background,
    border: `1px solid ${borderColor}`,
    borderRadius: theme.borderRadiusCommon,
    position: 'relative',
    ...disabledStyle,
  };
});

// tslint:disable-next-line:variable-name
const SInput = styled.textarea<{ blue: boolean }>(({ theme, blue }) => ({
  fontWeight: theme.font.weight.light,
  fontSize: theme.font.size.smallMedium2,
  lineHeight: '22px',
  boxSizing: 'border-box',
  color: theme.colors.grayDark,
  backgroundColor: 'transparent',
  borderWidth: 0,
  appearance: 'none',
  outline: 'none',
  padding: `${theme.spacing.medium}px ${theme.spacing.large}px`,
  width: '100%',
  '&:invalid': {
    boxShadow: 'none',
  },
  '::placeholder': {
    fontWeight: theme.font.weight.light,
    color: blue ? theme.colors.light : theme.colors.placeholder,
    fontSize: theme.font.size.smallMedium2,
  },
  '&:focus': {
    '::placeholder': {
      color: 'transparent',
    },
  },
}));

// tslint:disable-next-line:variable-name
const SErrorMessage = styled.span(({ theme }) => ({
  fontWeight: theme.font.weight.light,
  position: 'absolute',
  fontSize: theme.font.size.small,
  left: 7,
  bottom: -20,
  color: theme.colors.error,
}));

export enum InputType {
  Text = 'text',
  Number = 'number',
  Email = 'email',
  Password = 'password',
}

export enum InputBackground {
  White = 'white',
  Gray = '#f6f6f6',
}

export interface IInputProps {
  type?: InputType;
  name: string;
  value: string;
  disabled?: boolean;
  readOnly?: boolean;
  blue?: boolean;
  pattern?: string;
  maxLength?: number;
  enableAutoComplete?: boolean;
  placeholder?: string;
  className?: string;
  rows: number;
  dataAt?: string;
  label?: string | React.ReactChild;
  error?: string;
  background?: InputBackground;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLTextAreaElement>) => void;
}

export default class TextArea extends React.Component<IInputProps> {
  static defaultProps = {
    type: InputType.Text,
    disabled: false,
    readOnly: false,
    enableAutoComplete: false,
    blue: false,
    value: '',
    rows: 5,
  };

  private handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;
    if (this.props.pattern && !new RegExp(this.props.pattern).test(value)) {
      return;
    }
    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  };

  public render() {
    const inputOptions = {
      id: this.props.name,
      name: this.props.name,
      value: this.props.value,
      disabled: this.props.disabled,
      readOnly: this.props.readOnly,
      blue: this.props.blue || false,
      placeholder: this.props.placeholder,
      autoComplete: this.props.enableAutoComplete ? undefined : 'off',
      autoCapitalize: 'none',
      autoCorrect: 'off',
      maxLength: this.props.maxLength,
      'data-at': this.props.dataAt,
      onChange: this.handleOnChange,
      onClick: this.props.onClick,
      rows: this.props.rows,
    };

    return (
      <SInputOuterWrap className={this.props.className}>
        {this.props.label && <InputLabel dataAt={`${this.props.dataAt}-label`}>{this.props.label}</InputLabel>}
        <SInputInnerWrap className="inputInnerWrap" background={this.props.background || InputBackground.Gray} error={Boolean(this.props.error)} disabled={this.props.disabled || false}>
          <SInput {...inputOptions} />
        </SInputInnerWrap>
        {this.props.error && <SErrorMessage data-at={`${this.props.name}Error`}>{this.props.error}</SErrorMessage>}
      </SInputOuterWrap>
    );
  }
}
